import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';


export function softDeleteAdvertisement(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Advertisement/SoftdeleteAdvertisement/${id}`, {}, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}